import { useCallback } from "react";

const STORAGE_PREFIX = "project-last-tab-path";

function getStorageKey(projectId: string, tab: string): string {
  return `${STORAGE_PREFIX}:${projectId}:${tab}`;
}

export function useLastTabPath(projectId: string | undefined) {
  const savePath = useCallback(
    (tab: string, path: string) => {
      if (!projectId) return;
      localStorage.setItem(getStorageKey(projectId, tab), path);
    },
    [projectId],
  );

  const getPath = useCallback(
    (tab: string, defaultPath: string): string => {
      if (!projectId) return defaultPath;
      return localStorage.getItem(getStorageKey(projectId, tab)) || defaultPath;
    },
    [projectId],
  );

  return { savePath, getPath };
}
